import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Import page components
import HomePage from "./pages/Home";
import AboutPage from "./pages/About";
import PressReleaseGallery from "./pages/PressReleaseGallery";
import ProductCatalog from "./pages/ProductCatalog";
import ContactUs from "./pages/Contact";
import UtpannProduction from "./pages/UtpannProduction";
import ProductDetails from "./pages/ProductDetails";
import ProductDetails2 from "./pages/ProductDetails2";
import ProductDetails9 from "./pages/ProductDetails9";
import ProductDetails10 from "./pages/ProductDetails10";
import ProductDetails11 from "./pages/ProductDetails11";
import ProductDetails13 from "./pages/ProductDetails13";
import ProductDetails3 from "./pages/ProductDetails3";
import ProductDetails4 from "./pages/ProductDetails4";
import ProductDetails5 from "./pages/ProductDetails5";
import ProductDetails6 from "./pages/ProductDetails6";
import ProductDetails7 from "./pages/ProductDetails7";
import ProductDetails8 from "./pages/ProductDetails8";
import ProductDetails12 from "./pages/ProductDetails12";
import ScrollToTop from "./components/common/ScrollToTop";

const AppRoutes = () => {
  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route
          path="/press-release-gallery"
          element={<PressReleaseGallery />}
        />
        <Route path="/products" element={<ProductCatalog />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/utpann-network" element={<UtpannProduction />} />
        <Route path="/UtpannKesariPhos" element={<ProductDetails />} />
        <Route path="/UtpannGardenNest" element={<ProductDetails2 />} />
        <Route path="/UtpannPlantBooster" element={<ProductDetails3 />} />
        <Route path="/UtpannSuper" element={<ProductDetails4 />} />
        <Route path="/UtpannPRO" element={<ProductDetails5 />} />
        <Route path="/UtpannUMax" element={<ProductDetails6 />} />
        <Route path="/UtpannDefensio" element={<ProductDetails7 />} />
        <Route path="/UtpannZSB" element={<ProductDetails8 />} />
        <Route path="/UtpannPSF" element={<ProductDetails9 />} />
        <Route path="/UtpannPSB" element={<ProductDetails10 />} />
        <Route path="/UtpannMYCO" element={<ProductDetails11 />} /> 
        <Route path="/UtpannCBC-19" element={<ProductDetails12 />} />
        <Route path="/UtpannOrganicManure" element={<ProductDetails13 />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
